import { jsx as _jsx } from "react/jsx-runtime";
import { Box, FactSlogan, freddyTheme } from '@coolblue-development/freddy';
export const FactSloganElement = ({ fact, slogan, size }) => (_jsx(Box, { p: 600, backgroundColor: freddyTheme.color.background.primary, sx: {
        position: 'absolute',
        borderRadius: freddyTheme.borderRadius[100],
        zIndex: 1,
        bottom: freddyTheme.spacing[600],
        left: freddyTheme.spacing[600],
    }, children: _jsx(FactSlogan, { fact: fact, slogan: slogan, size: size, variant: "inverse" }) }));
//# sourceMappingURL=FactSloganElement.js.map